<h1 class="flex justify-between"><span>Scholarship List</span><span>School Year: <span>{{schoolYear | schoolYear}}</span></span></h1>
<mat-divider></mat-divider>
<p>
    A table of all scholarships for the current school-year.
</p>

<div class="w-fit mt-[20px] mx-auto">
    <mat-form-field class="w-full">
        <mat-label>Search...</mat-label>
        <input matInput (keyup)="applyFilter($event)" [(ngModel)]="input">
    </mat-form-field>

    <table mat-table [dataSource]="dataSource" matSort matSortDisableClear="true" (matSortChange)="sortChange($event)">
        <ng-container matColumnDef="MasterID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Master ID</th>
            <td mat-cell *matCellDef="let row">{{row.MasterID}}</td>
        </ng-container>
        <ng-container matColumnDef="ScholarshipName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Scholarship Name</th>
            <td mat-cell *matCellDef="let row">{{row.ScholarshipName}}</td>
        </ng-container>
        <ng-container matColumnDef="Active">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
            <td mat-cell *matCellDef="let row">{{row.Active ? 'Active' : 'Inactive'}}</td>
        </ng-container>
        <ng-container matColumnDef="Advertised">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Advertised</th>
            <td mat-cell *matCellDef="let row">{{row.Advertised ? 'Advertised' : 'Not Advertised'}}</td>
        </ng-container>
        <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let row">
                <button mat-raised-button type="button" [routerLink]="['/scholarship-details', row.MasterID]" matTooltip="View scholarship details" class="mr-[5px]">View</button>
                <button mat-raised-button type="button" [routerLink]="['/edit-scholarship', row.MasterID]" matTooltip="Edit scholarship details" class="mr-[5px]">Edit</button>
                <button mat-raised-button type="button" [routerLink]="['/preview', row.MasterID]" matTooltip="Preview what scholarship will look like in student selection">Preview</button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" [ngClass]="{ evenRows: even }"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-red-500 text-center" colspan="3">No data found</td>
        </tr>
    </table>
    <mat-divider></mat-divider>
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 50, 100, 500]" (page)="handlePageEvent($event)" [pageIndex]="pageIndex"></mat-paginator>
</div>